var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-fluid change-log",
      staticStyle: { height: "100%" },
    },
    [
      _c("loading", {
        attrs: { active: _vm.loading, "can-cancel": true },
        on: {
          "update:active": function ($event) {
            _vm.loading = $event
          },
        },
      }),
      _c("div", { staticClass: "row mt-2" }, [
        _c("div", { staticClass: "col-12 text-center mt-2" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("activityLog")))]),
        ]),
      ]),
      _c("div", { staticClass: "row mt-2" }, [
        _c("div", { staticClass: "col-1" }),
        _c("div", { staticClass: "col-10 pl-0 pr-0" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-4" }, [
              _vm.paging.length > 1
                ? _c(
                    "ul",
                    { staticClass: "paging-list" },
                    _vm._l(_vm.paging, function (page, index) {
                      return _c("li", { key: index }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-sm",
                            attrs: { type: "button", disabled: page.disabled },
                            on: {
                              click: function ($event) {
                                return _vm.paginate(page.number)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(page.number) + " ")]
                        ),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-1" }),
        _c("div", { staticClass: "col-10 pl-0 pr-0" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-2 input-group input-group-sm" }, [
              _c("div", { staticClass: "input-group-prepend" }, [
                _c("span", { staticClass: "input-group-text" }, [
                  _vm._v(_vm._s(_vm.$t("filterByPlant")) + ":"),
                ]),
              ]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.plantForFilter,
                      expression: "plantForFilter",
                    },
                  ],
                  staticClass: "form-control",
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.plantForFilter = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      function ($event) {
                        return _vm.assignFilteredUnits()
                      },
                    ],
                  },
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v(" " + _vm._s(_vm.$t("none")) + " "),
                  ]),
                  _vm._l(_vm.plantsFilter, function (plant, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: plant } },
                      [_vm._v(" " + _vm._s(plant.name) + " ")]
                    )
                  }),
                ],
                2
              ),
            ]),
            _c("div", { staticClass: "col-2 input-group input-group-sm" }, [
              _c("div", { staticClass: "input-group-prepend" }, [
                _c("span", { staticClass: "input-group-text" }, [
                  _vm._v(_vm._s(_vm.$t("filterByUnit")) + ":"),
                ]),
              ]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.plantUnitForFilter,
                      expression: "plantUnitForFilter",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { disabled: _vm.plantsFilter.length === 0 },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.plantUnitForFilter = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v(" " + _vm._s(_vm.$t("none")) + " "),
                  ]),
                  _vm._l(_vm.plantUnitsFilter, function (unit, index) {
                    return _c(
                      "option",
                      { key: index, domProps: { value: unit } },
                      [_vm._v(" " + _vm._s(unit.name) + " ")]
                    )
                  }),
                ],
                2
              ),
            ]),
            _c("div", { staticClass: "col-2 input-group input-group-sm" }, [
              _c("div", { staticClass: "input-group-prepend" }, [
                _c("span", { staticClass: "input-group-text" }, [
                  _vm._v(_vm._s(_vm.$t("filterByEmail")) + ":"),
                ]),
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.emailFilter,
                    expression: "emailFilter",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", placeholder: _vm.$t("email") },
                domProps: { value: _vm.emailFilter },
                on: {
                  keyup: function ($event) {
                    return _vm.filterAndSortOnEnter($event)
                  },
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.emailFilter = $event.target.value
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "col-2 input-group input-group-sm" }, [
              _c("div", { staticClass: "input-group-prepend" }, [
                _c("span", { staticClass: "input-group-text" }, [
                  _vm._v(_vm._s(_vm.$t("filterByAction")) + ":"),
                ]),
              ]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.actionFilterValue,
                      expression: "actionFilterValue",
                    },
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.actionFilterValue = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.actionFilter, function (filter, index) {
                  return _c(
                    "option",
                    { key: index, domProps: { value: filter.value } },
                    [_vm._v(" " + _vm._s(filter.label) + " ")]
                  )
                }),
                0
              ),
            ]),
            _c("div", { staticClass: "col-2 input-group input-group-sm" }, [
              _c("div", { staticClass: "input-group-prepend" }, [
                _c("span", { staticClass: "input-group-text" }, [
                  _vm._v(_vm._s(_vm.$t("sortByDate")) + ":"),
                ]),
              ]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dateSortValue,
                      expression: "dateSortValue",
                    },
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.dateSortValue = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.dateSort, function (type, index) {
                  return _c(
                    "option",
                    { key: index, domProps: { value: type.value } },
                    [_vm._v(" " + _vm._s(type.label) + " ")]
                  )
                }),
                0
              ),
            ]),
            _c("div", { staticClass: "col-2" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary btn-sm",
                  staticStyle: { width: "200px" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.doFilterAndSort()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("filter")) + " ")]
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "col-1" }),
      ]),
      _c("div", { staticClass: "row mt-2", staticStyle: { height: "100%" } }, [
        _c("div", { staticClass: "col-1" }),
        _c("div", { staticClass: "col-10" }, [
          _c("div", { staticClass: "row mt-2 change-log-list-container" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "row header-row pt-2" }, [
                _c("div", { staticClass: "col-1" }),
                _c("div", { staticClass: "col-2" }, [
                  _c("strong", [_vm._v(_vm._s(_vm.$t("email")))]),
                ]),
                _c("div", { staticClass: "col-2" }, [
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.$t("plant")) + " / " + _vm._s(_vm.$t("unit"))
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "col-5" }, [
                  _c("strong", [_vm._v(_vm._s(_vm.$t("action")))]),
                ]),
                _c("div", { staticClass: "col-2" }, [
                  _c("strong", [_vm._v(_vm._s(_vm.$t("date")))]),
                ]),
              ]),
              !_vm.loading
                ? _c("div", { staticClass: "row change-log-list" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _vm.logs.length === 0
                          ? _c("div", { staticClass: "row log-item pl-1" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("noItemsToShow")) + " "
                                ),
                              ]),
                            ])
                          : _vm._l(_vm.logs, function (item, index) {
                              return _c(
                                "div",
                                { key: index, staticClass: "row log-item" },
                                [
                                  _c("div", { staticClass: "col-1" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          (_vm.params.page - 1) * 30 + index + 1
                                        ) +
                                        ". "
                                    ),
                                  ]),
                                  _c("div", { staticClass: "col-2" }, [
                                    _vm._v(" " + _vm._s(item.user) + " "),
                                  ]),
                                  _c("div", { staticClass: "col-2" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(item.plantName) +
                                        " / " +
                                        _vm._s(
                                          item.unitName === null
                                            ? "N/A"
                                            : item.unitName
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("div", { staticClass: "col-5" }, [
                                    _c(
                                      "span",
                                      { class: _vm.actionClass(item.action) },
                                      [
                                        _vm._v(
                                          _vm._s(item.action) +
                                            " " +
                                            _vm._s(item.object)
                                        ),
                                      ]
                                    ),
                                    _vm._v(" " + _vm._s(item.name) + " "),
                                  ]),
                                  _c("div", { staticClass: "col-2" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("on")) +
                                        ": " +
                                        _vm._s(
                                          _vm._f("dateFormat")(
                                            new Date(item.date),
                                            "YYYY-MM-DD HH:mm:ss"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ]
                              )
                            }),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "col-1" }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }